import notification from 'app/config/notification';
import { LICENSE_CHAGES_TYPE, SERVICES_CODES, SERVICES_PROPERTIES } from 'app/config/services';
import { validateDocumentsDescription } from '../functions';

const filterBoExcluido = data => {
  if (!data) return [];
  return data.filter(c => !c.boExcluido);
};

export const validatePassengersByVehicle = (
  vehicles,
  passengers,
  event = {
    submit: false,
  }
) => {
  passengers = filterBoExcluido(passengers);

  const vehiclesPlate = [];
  const numPassangers = event.submit ? passengers.length - 1 : passengers.length;
  vehicles.forEach(({ veiculo }) => {
    if (!veiculo) {
      return;
    }
    const { qtCapacidade, dePlaca } = veiculo;

    if (qtCapacidade <= numPassangers) {
      vehiclesPlate.push(dePlaca);
    }
  });

  if (vehiclesPlate.length > 0) {
    if (event.submit) {
      notification(
        `A quantidade de passageiros, excede o limite do(s) veículo(s) ${vehiclesPlate.join(
          ', '
        )}. Favor corrigir.`,
        {
          toastId: 'MESSAGES.SERVICE.FORMS.DOCUMENT_DESCRIPTION_REQUIRED',
          type: 'error',
        }
      );
    } else {
      notification(
        `A quantidade de passageiros, excederá o limite do(s) veículo(s) ${vehiclesPlate.join(
          ', '
        )}.`,
        {
          toastId: 'MESSAGES.SERVICE.FORMS.DOCUMENT_DESCRIPTION_REQUIRED_#1',
          type: 'warning',
        }
      );
    }

    return false;
  }
  return true;
};

export const validateLicenseRequest = ({ values, cdServico, intl, isInternalForm }) => {
  const docsExtrasValidation = validateDocumentsDescription(values.documentos);
  let errors = {};

  let passageiros = filterBoExcluido(values.passageiros);
  let itinerario = filterBoExcluido(values.itinerario);
  let horarios = filterBoExcluido(values.horarios);
  let empresas = filterBoExcluido(values.empresas);
  let licencaVeiculos = filterBoExcluido(values.licencaVeiculos);

  if (!isInternalForm && values.documentos?.length === 0) {
    notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_MANDATORY_INFOS' }), {
      toastId: 'MISSING_MANDATORY_INFOS',
      type: 'warning',
    });
    errors.documents = true;
    return errors;
  }

  if (!docsExtrasValidation && !isInternalForm) {
    notification(
      intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.DOCUMENT_DESCRIPTION_REQUIRED' }),
      {
        toastId: 'MESSAGES.SERVICE.FORMS.DOCUMENT_DESCRIPTION_REQUIRED',
        type: 'error',
      }
    );
    errors.documents = true;
  }

  if (!passageiros || passageiros.length === 0) {
    if (
      cdServico === SERVICES_CODES.LICENCA_VIAGEM_EVENTUAL ||
      cdServico === SERVICES_CODES.LICENCA_FRETAMENTO_UNIVERSITARIOS ||
      cdServico === SERVICES_CODES.LICENCA_ESCOLAR
    ) {
      notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_PASSANGERS' }), {
        toastId: 'MESSAGES.SERVICE.FORMS.MISSING_PASSANGERS',
        type: 'error',
      });
      errors.passengers = true;
    }
  } else {
    if (
      !validatePassengersByVehicle(licencaVeiculos, passageiros, {
        submit: true,
      })
    ) {
      errors.passengers = true;
    }
  }

  if (!itinerario || itinerario.length < 2) {
    if (
      cdServico !== SERVICES_CODES.LICENCA_VIAGEM_EVENTUAL &&
      cdServico !== SERVICES_CODES.LICENCA_TURISMO &&
      cdServico !== SERVICES_CODES.LICENCA_VINCULADA
    ) {
      notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_INTINERARY' }), {
        toastId: 'MESSAGES.SERVICE.FORMS.MISSING_INTINERARY',
        type: 'error',
      });
      errors.itinerary = true;
    }
  } else {
    const cdFirstCity = itinerario[0]?.cdMunicipio;
    const equalCitiesCounter = itinerario.reduce(
      (counter, { cdMunicipio }) => (cdFirstCity === cdMunicipio ? (counter += 1) : counter),
      0
    );
    if (equalCitiesCounter < 2) {
      notification(
        intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.LAST_ELEMENT_NEEDS_EQUAL_FIRST' }),
        {
          toastId: 'MESSAGES.SERVICE.FORMS.LAST_ELEMENT_NEEDS_EQUAL_FIRST',
          type: 'error',
        }
      );
      errors.itinerary = true;
    }
  }

  if (!horarios || horarios.length === 0) {
    if (
      cdServico !== SERVICES_CODES.LICENCA_VIAGEM_EVENTUAL &&
      cdServico !== SERVICES_CODES.LICENCA_TURISMO &&
      cdServico !== SERVICES_CODES.LICENCA_VINCULADA
    ) {
      notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_SCHEDULE' }), {
        toastId: 'MESSAGES.SERVICE.FORMS.MISSING_SCHEDULE',
        type: 'error',
      });
      errors.schedules = true;
    }
  }

  if (!empresas || empresas.length === 0) {
    if (
      cdServico !== SERVICES_CODES.LICENCA_VIAGEM_EVENTUAL &&
      cdServico !== SERVICES_CODES.LICENCA_TURISMO &&
      cdServico !== SERVICES_CODES.LICENCA_VINCULADA
    ) {
      notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_COMPANIES' }), {
        toastId: 'MESSAGES.SERVICE.FORMS.MISSING_COMPANIES',
        type: 'error',
      });
      errors.companies = true;
    }
  }

  if (!licencaVeiculos || licencaVeiculos.length === 0) {
    if (cdServico !== SERVICES_CODES.LICENCA_VIAGEM_EVENTUAL) {
      notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_VEHICLES' }), {
        toastId: 'MESSAGES.SERVICE.FORMS.MISSING_VEHICLES',
        type: 'error',
      });
      errors.vehicles = true;
    }
  }
  return errors;
};

export const validateLicenseDuplicateRequest = ({ values, oldData, intl, isInternalForm }) => {
  let errors = {};
  let configurator = {};

  let passageiros = filterBoExcluido(values.passageiros);
  let itinerario = filterBoExcluido(values.itinerario);
  let horarios = filterBoExcluido(values.horarios);
  let empresas = filterBoExcluido(values.empresas);
  let licencaVeiculos = filterBoExcluido(values.licencaVeiculos);

  const cdServico = oldData?.oldService?.cdServico
    ? oldData.oldService.cdServico
    : oldData?.oldRequest?.cdServico
    ? oldData.oldRequest.cdServico
    : null;

  if (!isInternalForm && values.documentos?.length === 0) {
    notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_MANDATORY_INFOS' }), {
      toastId: 'MISSING_MANDATORY_INFOS',
      type: 'warning',
    });
    errors.documents = true;
    return errors;
  }

  if (cdServico && SERVICES_PROPERTIES[cdServico].configurator) {
    configurator = {...SERVICES_PROPERTIES[cdServico].configurator};
    configurator.hasItinerary = false;
  }

  const docsExtrasValidation = validateDocumentsDescription(values.documentos);
  if (!docsExtrasValidation && !isInternalForm) {
    notification(
      intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.DOCUMENT_DESCRIPTION_REQUIRED' }),
      {
        toastId: 'MESSAGES.SERVICE.FORMS.DOCUMENT_DESCRIPTION_REQUIRED',
        type: 'error',
      }
    );
    errors.documents = true;
  }

  if (values.cdTipoAlteracaoLicenca === LICENSE_CHAGES_TYPE.MUDANCA_CONTRATO) {
    if (configurator.hasPassengers && (!passageiros || passageiros.length === 0)) {
      notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_PASSANGERS' }), {
        toastId: 'MESSAGES.SERVICE.FORMS.MISSING_PASSANGERS',
        type: 'error',
      });
      errors.passengers = true;
    }
    if (configurator.hasSchedules && (!horarios || horarios.length === 0)) {
      notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_SCHEDULE' }), {
        toastId: 'MESSAGES.SERVICE.FORMS.MISSING_SCHEDULE',
        type: 'error',
      });
      errors.schedules = true;
    }
    if (configurator.hasCompanies && (!empresas || empresas.length === 0)) {
      notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_COMPANIES' }), {
        toastId: 'MESSAGES.SERVICE.FORMS.MISSING_COMPANIES',
        type: 'error',
      });
      errors.companies = true;
    }
    if (configurator.hasVehicle && (!licencaVeiculos || licencaVeiculos.length === 0)) {
      notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_VEHICLES' }), {
        toastId: 'MESSAGES.SERVICE.FORMS.MISSING_VEHICLES',
        type: 'error',
      });
      errors.vehicles = true;
    }

    if (configurator.hasItinerary) {
      if (!itinerario || itinerario.length < 2) {
        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_INTINERARY' }), {
          toastId: 'MESSAGES.SERVICE.FORMS.MISSING_INTINERARY',
          type: 'error',
        });
        errors.itinerary = true;
      } else {
        const cdFirstCity = itinerario[0]?.cdMunicipio;
        const equalCitiesCounter = itinerario.reduce(
          (counter, { cdMunicipio }) => (cdFirstCity === cdMunicipio ? (counter += 1) : counter),
          0
        );
        if (equalCitiesCounter < 2) {
          notification(
            intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.LAST_ELEMENT_NEEDS_EQUAL_FIRST' }),
            {
              toastId: 'MESSAGES.SERVICE.FORMS.LAST_ELEMENT_NEEDS_EQUAL_FIRST',
              type: 'error',
            }
          );
          errors.itinerary = true;
        }
      }
    }
    //  endif values.cdTipoAlteracaoLicenca === LICENSE_CHAGES_TYPE.MUDANCA_CONTRATO
  } else if (values.cdTipoAlteracaoLicenca === LICENSE_CHAGES_TYPE.MUDANCA_ITINERARIO) {
    if (!itinerario || itinerario.length < 2) {
      notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_INTINERARY' }), {
        toastId: 'MESSAGES.SERVICE.FORMS.MISSING_INTINERARY',
        type: 'error',
      });
      errors.itinerary = true;
    } else {
      const cdFirstCity = itinerario[0]?.cdMunicipio;
      const equalCitiesCounter = itinerario.reduce(
        (counter, { cdMunicipio }) => (cdFirstCity === cdMunicipio ? (counter += 1) : counter),
        0
      );
      if (equalCitiesCounter < 2) {
        notification(
          intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.LAST_ELEMENT_NEEDS_EQUAL_FIRST' }),
          {
            toastId: 'MESSAGES.SERVICE.FORMS.LAST_ELEMENT_NEEDS_EQUAL_FIRST',
            type: 'error',
          }
        );
        errors.itinerary = true;
      }
    }

    if (!licencaVeiculos || licencaVeiculos.length === 0) {
      notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_VEHICLES' }), {
        toastId: 'MESSAGES.SERVICE.FORMS.MISSING_VEHICLES',
        type: 'error',
      });
      errors.vehicles = true;
    }
    //  endif values.cdTipoAlteracaoLicenca === LICENSE_CHAGES_TYPE.MUDANCA_ITINERARIO
  }

  return errors;
};
